<div class="devis-success-wrapper" [class]="cssClass">
  <div class="image-group">
      <img
      [src]="'../../../../../assets/img/' + image"
      alt="devis created with success"
    />
  </div>  
  <span *ngIf="title" class="title">{{title}}</span>
  <p *ngIf="message" [innerHtml]="message"></p>
  <div class="buttons-group">
    <app-button
      *ngIf="validText.length"
      [typeNumber]="0"
      [innerText]="validText"
      [loading]="validLoading"
      [disabled]="buttonsDisabled"
      [styles]="{
        width: '100%',
        maxHeight: '40px',
        backgroundColor: '#75c2f6',
        color: '#fff',
        borderRadius: '15px'
      }"
      (onClick)="handleValid()"
    ></app-button>
    <app-button
      *ngIf="cancleText.length"
      [innerText]="cancleText"
      [loading]="cancelLoading"
      [disabled]="buttonsDisabled"
      [styles]="{
        class: 'cancle-btn',
        width: '100%',
        maxHeight: '40px',
        backgroundColor: '#88a8c7',
        color: '#fff',
        borderRadius: '15px'
      }"
      (onClick)="handleCancle()"
    ></app-button>
  </div>
</div>
